import template from './component.tpl.html';
import TicketTemplateEditorController from './controller';

angular.module('festzelt-os.modules.tickets.templates')
    .component('alTicketTemplateEditor', {
        bindings: {
            originalTemplate: '<',
            originalModel: '<',
            onModelChange: '&'
        },
        controller: TicketTemplateEditorController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/components/al-ticket-template-editor/component.js